export default "__VITE_ASSET__BLpZm81q__"